// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".svg-icon[data-v-61d4d952] {\n  overflow: hidden;\n  vertical-align: -0.15em;\n  fill: currentColor;\n}\n", ""]);
// Exports
module.exports = exports;
